export default __webpack_public_path__ + "static/media/purpple.1d74d5a6.png";